import { VisuallyHidden } from '@radix-ui/react-visually-hidden';
import { ComponentProps } from 'react';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalDescription,
  ModalTitle,
} from '../../../../../design-system/modal/modal';
import { ExcludeSenderModalContent } from './exclude-sender-modal-content';

type ExcludeSenderModalProps = {
  isOpen: boolean;
  invoiceInfo: ComponentProps<typeof ExcludeSenderModalContent>['invoiceInfo'];
  isLoading: boolean;
  onClose: () => void;
  onExcludeSender: () => Promise<void>;
};

export const ExcludeSenderModal = ({
  isOpen,
  invoiceInfo,
  isLoading,
  onClose,
  onExcludeSender,
}: ExcludeSenderModalProps) => {
  return (
    <Modal open={isOpen} onOpenChange={onClose}>
      <ModalContent className="h-max w-[520px] p-7">
        <VisuallyHidden>
          <ModalTitle>Exclude sender</ModalTitle>

          <ModalDescription>Exclude sender</ModalDescription>
        </VisuallyHidden>

        <ModalCloseButton onClick={onClose} aria-label="Close modal" />

        <ExcludeSenderModalContent invoiceInfo={invoiceInfo} isLoading={isLoading} onExcludeSender={onExcludeSender} />
      </ModalContent>
    </Modal>
  );
};
